import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    creatRole,
    GetSingleRole,
    roleAvailableTasks,
    UpdateRole,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import { useRoleRestrictionsArray } from './RoleRestriction';
import {
    EmployeesInCreate,
    HandleEmployeesWithRole,
} from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesSlice';
import {errorMsg} from "../../../../../Apis/functions";
import routes from "../../../../../Routes/routes";
import {MODELS} from "../../../../../Apis/Models";
import { ROLE_NAME_DEFAULT_MODEL } from '../../../../../enums/userTypeEnum';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const FunctionalityCreateNewRole = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { roleListData, singleRoleObj, updateRoleSuccess, creteRoleSuccess } = useSelector(
        (state) => state?.EmployeeRolesSlice,
    );
    const arrObj = useRoleRestrictionsArray();
    const [mobileAvailableList, setMobileAvaliableList] = useState([]);
    const [websiteAvailableList, setWebsiteAvailableList] = useState([]);
    const [mobileChooseList, setMobileChooseList] = useState([]);
    const [websiteChooseList, setWebsiteChooseList] = useState([]);
    const [mobileSelected, setMobileSelected] = useState([]);
    const [websiteSelected, setWebsiteSelected] = useState([]);
    const [deleteTask, setDeleteTask] = useState([]);
    const [roleDataById, setRoleDataById] = useState();
    const [mobileAll, setMobileAll] = useState([]);
    const [webAll, setWebAll] = useState([]);

    const { id } = useParams();
    // Initializes the state for role restrictions with default values
    const [roleRestrictions, setroleRestrictions] = useState([
        {
            name: 'biocrValidation',
            res: t('biocr_validation'),
            check: false,
            info: t('use_the_biocr_validatiaon_to_confirm_your_identity'),
        },
        {
            name: 'eventValidation',
            res: t('event_validation'),
            check: false,
            info: t('validate_the_event_who_created_in_this_role'),
        },
        {
            name: 'extraDataEmployee',
            res: t('extra_data_employee'),
            check: false,
            info: t('add_extra_data_to_the_employee'),
        },
        {
            name: 'keepSessionActiveWebApp',
            res: t('keep_session_active'),
            check: false,
            info: t('to_keep_the_session_al_the_time_active_in_the_web_app'),
        },

        {
            name: 'sharePdfInMobileApp',
            res: t('share_pdf_in_mobile_app'),
            check: false,
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'),
        },
        {
            name: 'useTokenWebApp',
            res: t('use_token_webapp'),
            check: false,
            info: t('to_use_the_6_degits_code_to_log_in_on_the_web_app'),
        },
    ]);
    const [roleName, setRoleName] = useState('');
    const [manageShow, setManageShow] = useState(false);
    const [update, setUpdate] = useState(false);
    const [selectedRestrictions, setSelectedRestrictions] = useState({
        biocrValidation: false,
        eventValidation: false,
        extraDataEmployee: false,
        id: '',
        keepSessionActiveWebApp: false,
        sharePdfInMobileApp: false,
        useTokenWebApp: false,
    });
    const [isInitialSetup, setIsInitialSetup] = useState(true);
    const [nameError, setNameError] = useState('');
    const [submitClicked, setSubmitClicked] = useState(false);
    const readOnly = Object.values(ROLE_NAME_DEFAULT_MODEL).includes(roleName?.toUpperCase());



    // Clear all form fields and reset role state
    const clearField = () => {
        setRoleName('');
        setroleRestrictions((prevState) => {
            const updatedCheckboxList = prevState.map((item) => ({ ...item, check: false }));
            return updatedCheckboxList;
        });

        setSelectedRestrictions({
            biocrValidation: false,
            eventValidation: false,
            extraDataEmployee: false,
            id: '',
            keepSessionActiveWebApp: false,
            sharePdfInMobileApp: false,
            useTokenWebApp: false,
        });

        const mr = roleListData?.filter((item) => item?.isMobileApp);
        const wr = roleListData?.filter((item) => !item?.isMobileApp);

        setMobileAvaliableList(mr);
        setWebsiteAvailableList(wr);
        setWebsiteChooseList([]);
        setMobileChooseList([]);

        let db = [...mr, ...wr];
        const deleteState = db.filter((item) =>
            singleRoleObj?.currentTasks?.some((selectedItem) => selectedItem.id === item.id),
        );
        setDeleteTask(deleteState);
    };
    useEffect(() => {
        if (!id) {
            clearField();
        }
    }, [id]);

    // Handle click events on task lists for mobile/web and add/remove logic
    const handleTaskListClick = (payload) => {
        switch (payload.check) {
            case 1:
                if (payload.selected.option) {
                    setWebsiteChooseList((prevArray) => [...prevArray, payload.selected]);
                    setWebsiteAvailableList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                } else {
                    setDeleteTask((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                    setWebsiteChooseList((prevArray) => [...prevArray, payload.selected]);
                    setWebsiteAvailableList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                }
                break;
            case 2:
                if (payload.selected.option) {
                    setMobileChooseList((prevArray) => [...prevArray, payload.selected]);
                    setMobileAvaliableList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                } else {
                    setDeleteTask((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                    setMobileChooseList((prevArray) => [...prevArray, payload.selected]);
                    setMobileAvaliableList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                }
                break;
            case 3:
                if (payload.selected.option) {
                    setMobileAvaliableList((prevArray) => [...prevArray, payload.selected]);
                    setMobileChooseList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                } else {
                    setDeleteTask((prev) => [...prev, payload.selected]);
                    setMobileAvaliableList((prevArray) => [...prevArray, payload.selected]);
                    setMobileChooseList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                }
                break;
            case 4:
                if (payload.selected.option) {
                    setWebsiteAvailableList((prevArray) => [...prevArray, payload.selected]);
                    setWebsiteChooseList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                } else {
                    setDeleteTask((prev) => [...prev, payload.selected]);
                    setWebsiteAvailableList((prevArray) => [...prevArray, payload.selected]);
                    setWebsiteChooseList((prevArray) => prevArray.filter((obj) => obj.id !== payload.selected?.id));
                }

                break;
            case 5:
                const mr = roleListData?.filter((item) => item?.isMobileApp);
                const wr = roleListData?.filter((item) => !item?.isMobileApp);
                setMobileAvaliableList([]);
                setWebsiteAvailableList([]);
                setWebsiteChooseList(wr);
                setMobileChooseList(mr);
                break;
            case 6:
                const ma = roleListData?.filter((item) => item?.isMobileApp);
                const wa = roleListData?.filter((item) => !item?.isMobileApp);
                setMobileAvaliableList(ma);
                setWebsiteAvailableList(wa);
                setWebsiteChooseList([]);
                setMobileChooseList([]);
                let db = [...ma, ...wa];
                const deleteState = db.filter((item) =>
                    singleRoleObj?.currentTasks?.some((selectedItem) => selectedItem.id === item.id),
                );
                setDeleteTask(deleteState);
                break;
            default:
                toast.warn('invalid check');
                break;
        }
    };
    // Handle changes in the role name input field
    const handleNameChange = (e) => {
        const value = e.target.value;
        if (value.trim() === '') {
            toast.info(t('please_fill_all_fields'));
            setNameError('privilege_name_required');
        } else {
            setNameError('');
        }

        setRoleName(value);
    };
    // Handle creation or updating of a role based on the presence of an ID
    const handleCreateRole = () => {
        if (roleName.trim() !== '') {
            if (id) {
                const addTasks = [...mobileChooseList, ...websiteChooseList].map((item) => ({ id: item.id }));

                if (addTasks.length === 0) {
                    toast.warn(t('please_select_privilege'));
                    return;
                }

                const removeTasks = [...deleteTask].map((item) => ({ id: item.id }));
                const updateData = {
                    id: singleRoleObj?.id,
                    addTasks,
                    removeTasks,
                    name: roleName,
                    roleRestriction: {
                        roleId: singleRoleObj?.roleRestriction?.roleId,
                        id: singleRoleObj?.roleRestriction?.id,
                        biocrValidation: selectedRestrictions?.biocrValidation,
                        eventValidation: selectedRestrictions?.eventValidation,
                        extraDataEmployee: selectedRestrictions?.extraDataEmployee,
                        keepSessionActiveWebApp: selectedRestrictions?.keepSessionActiveWebApp,
                        sharePdfInMobileApp: selectedRestrictions?.sharePdfInMobileApp,
                        useTokenWebApp: selectedRestrictions?.useTokenWebApp,
                    },
                };
                dispatch(UpdateRole(updateData)).then(
                    ({
                        payload: {
                            data: { success, code },
                        },
                    }) => {
                        if (success !== true) {
                            errorMsg(code);
                        } else {
                            dispatch(GetSingleRole(id)); 
                        }
                    },
                );
            } else {
                const addTasks = [...mobileChooseList, ...websiteChooseList].map((item) => ({ id: item.id }));

                if (addTasks.length === 0) {
                    toast.warn(t('please_select_privilege'));
                    return;
                }

                const data = {
                    addTasks,
                    name: roleName,
                    removeTasks: null,
                    roleRestriction: {
                        biocrValidation: selectedRestrictions?.biocrValidation,
                        eventValidation: selectedRestrictions?.eventValidation,
                        extraDataEmployee: selectedRestrictions?.extraDataEmployee,
                        keepSessionActiveWebApp: selectedRestrictions?.keepSessionActiveWebApp,
                        sharePdfInMobileApp: selectedRestrictions?.sharePdfInMobileApp,
                        useTokenWebApp: selectedRestrictions?.useTokenWebApp,
                    },
                };
                dispatch(creatRole(data))
                    .then(({payload: {data: { success ,code},},}) => {
                            if (success === true) {
                                navigate(routes.roles.list);
                            } else errorMsg(code)
                        },
                    );
            }
        } else {
            toast.info(t('please_fill_all_fields'));
            setSubmitClicked(true);
        }
    };
    // Reset selected mobile and website tasks on initial render
    useEffect(() => {
        setDeleteTask([]);
        setMobileChooseList([]);
        setWebsiteChooseList([]);
    }, []);
    // Mark the component as ready for update logic
    useEffect(() => {
        setUpdate(true);
        dispatch(EmployeesInCreate([]));
        dispatch(HandleEmployeesWithRole([]));
        dispatch(roleAvailableTasks());
    }, []);
    // When role list data is available or updated, split it into mobile and website roles
    useEffect(() => {
    if (!roleListData) return;

    const permissionsToHide = [MODELS.Guard];
    const filtered = roleListData.filter(t => !permissionsToHide.includes(t.moduleId));

    setMobileAll(filtered.filter(i => i.isMobileApp));
    setWebAll(filtered.filter(i => !i.isMobileApp));
}, [roleListData]);


    // When editing a role (based on ID), fetch its data and prefill the form
    useEffect(() => {
        if (id) dispatch(GetSingleRole(id));
    }, [id]);
    useEffect(() => {
        if (!id) return; 
        if (!singleRoleObj) return;
        setRoleName(singleRoleObj?.name);
        setroleRestrictions(arrObj);
        setRoleDataById(singleRoleObj);
        setSelectedRestrictions(singleRoleObj.roleRestriction || {});

        const arr1 =
            singleRoleObj.currentTasks?.filter((i) => i.isMobileApp).map((i) => ({ ...i, option: false })) || [];

        const arr2 =
            singleRoleObj.currentTasks?.filter((i) => !i.isMobileApp).map((i) => ({ ...i, option: false })) || [];

        setMobileChooseList(arr1);
        setWebsiteChooseList(arr2);
    }, [singleRoleObj]);

    // Handles drag-and-drop events into the "Available" column.
    const handleDropAvailable = (item) => {
        if (item.column != 'Available') {
            handleTaskListClick({
                selected: item.selected,
                check: item.check,
            });
        }
    };
    // Handles drag-and-drop events into the "Chosen" column.
    const handleDropChoosed = (item) => {
        if (item.column != 'Choosed') {
            handleTaskListClick({
                selected: item.selected,
                check: item.check,
            });
        }
    };

    useEffect(() => {
    setMobileAvaliableList(
        mobileAll.filter(a => !mobileChooseList.some(c => c.id === a.id))
    );
    setWebsiteAvailableList(
        webAll.filter(a => !websiteChooseList.some(c => c.id === a.id))
    );
}, [mobileAll, webAll, mobileChooseList, websiteChooseList]);


    return {
        clearField,
        handleNameChange,
        roleName,
        submitClicked,
        handleTaskListClick,
        handleDropAvailable,
        handleDropChoosed,
        roleListData,
        mobileAvailableList,
        setMobileAvaliableList,
        websiteAvailableList,
        setWebsiteAvailableList,
        mobileChooseList,
        setMobileChooseList,
        websiteChooseList,
        setWebsiteChooseList,
        mobileSelected,
        setMobileSelected,
        websiteSelected,
        setWebsiteSelected,
        handleCreateRole,
        manageShow,
        setManageShow,
        id,
        readOnly,
    };
};
export default FunctionalityCreateNewRole;
